(() => {
  const A = window.ALEYA || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* money: follows the store's money format, so prices written by JS match the ones rendered by Liquid */
  const money = (cents) => {
    const fmt = (A.moneyFormat || '{{amount}} lei').replace(/<[^>]+>/g, '');
    const v = Math.abs(cents) / 100;
    const group = (s, th) => s.replace(/\B(?=(\d{3})+(?!\d))/g, th);
    const two = (dec, th) => { const [i, d] = v.toFixed(2).split('.'); return group(i, th) + dec + d; };
    const none = (th) => group(String(Math.round(v)), th);
    let s;
    if (/no_decimals_with_comma_separator/.test(fmt)) s = none('.');
    else if (/no_decimals_with_space_separator/.test(fmt)) s = none(' ');
    else if (/no_decimals/.test(fmt)) s = none(',');
    else if (/with_comma_separator/.test(fmt)) s = two(',', '.');
    else if (/with_space_separator/.test(fmt)) s = two(',', ' ');
    else if (/with_apostrophe_separator/.test(fmt)) s = two('.', "'");
    else s = two('.', ',');
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, s).trim();
  };

  /* toast */
  const toast = (msg) => {
    const t = $('#toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('is-visible');
    clearTimeout(t._t);
    t._t = setTimeout(() => t.classList.remove('is-visible'), 2200);
  };

  /* header shadow + home sticky CTA */
  const hdr = $('.hdr');
  const mcta = $('.mcta');
  const onScroll = () => {
    const y = scrollY;
    if (hdr) hdr.classList.toggle('is-scrolled', y > 8);
    if (mcta) {
      const h = document.body.scrollHeight - innerHeight;
      mcta.classList.toggle('is-visible', y > 520 && y < h - 760);
    }
  };
  addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* mobile menu */
  const menu = $('#menu');
  const menuButtons = $$('[data-menu-open]');
  const openMenu = () => {
    if (!menu) return;
    menu.classList.add('is-open'); document.body.classList.add('no-scroll');
    menuButtons.forEach((b) => b.setAttribute('aria-expanded', 'true'));
    $('.menu__close', menu)?.focus();
  };
  const closeMenu = () => {
    if (!menu || !menu.classList.contains('is-open')) return;
    menu.classList.remove('is-open'); document.body.classList.remove('no-scroll');
    menuButtons.forEach((b) => b.setAttribute('aria-expanded', 'false'));
    menuButtons[0]?.focus();
  };
  $$('[data-menu-open]').forEach((b) => b.addEventListener('click', openMenu));
  $$('[data-menu-close]').forEach((b) => b.addEventListener('click', closeMenu));

  /* reveal on scroll */
  if ('IntersectionObserver' in window && !reduce) {
    const io = new IntersectionObserver((es) => es.forEach((e) => {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    }), { rootMargin: '0px 0px -8% 0px' });
    $$('.reveal').forEach((el, i) => { el.style.transitionDelay = (i % 4) * 60 + 'ms'; io.observe(el); });
  } else {
    $$('.reveal').forEach((el) => el.classList.add('is-in'));
  }

  /* fără înclinare 3D: cardurile rămân drepte, doar poza face un zoom discret */

  /* animated accordions */
  const bindAcc = (root = document) => $$('details.acc', root).forEach((d) => {
    if (d._bound) return; d._bound = true;
    const s = $('summary', d); const b = $('.acc__body', d);
    if (!s || !b || reduce) return;
    s.addEventListener('click', (e) => {
      e.preventDefault();
      const ease = 'height .35s cubic-bezier(.22,.8,.26,1)';
      if (d.open) {
        b.style.height = b.scrollHeight + 'px';
        requestAnimationFrame(() => { b.style.transition = ease; b.style.height = '0px'; });
        b.addEventListener('transitionend', () => { d.open = false; b.style.height = ''; b.style.transition = ''; }, { once: true });
      } else {
        d.open = true;
        const h = b.scrollHeight; b.style.height = '0px';
        requestAnimationFrame(() => { b.style.transition = ease; b.style.height = h + 'px'; });
        b.addEventListener('transitionend', () => { b.style.height = ''; b.style.transition = ''; }, { once: true });
      }
    });
  });
  bindAcc();

  /* ---------- cart ---------- */
  const drawer = $('#cart-drawer');
  let drawerReturn = null;
  /* while the drawer is open the rest of the page is inert, so Tab and screen readers stay inside the dialog */
  const setInert = (on) => {
    if (!drawer) return;
    Array.from(document.body.children).forEach((el) => {
      if (el.contains(drawer) || el.id === 'toast' || /^(SCRIPT|STYLE|LINK)$/.test(el.tagName)) return;
      if (on) el.setAttribute('inert', ''); else el.removeAttribute('inert');
    });
  };
  const setCount = (n) => {
    $$('[data-cart-count]').forEach((el) => { el.textContent = n; el.dataset.count = n; });
    $$('[data-cart-open]').forEach((el) => el.setAttribute('aria-label', n ? `Coș, ${n} ${n === 1 ? 'produs' : 'produse'}` : 'Coș, gol'));
  };
  const openDrawer = () => {
    if (!drawer) return;
    drawerReturn = document.activeElement;
    drawer.classList.add('is-open'); document.body.classList.add('no-scroll'); setInert(true);
    $('button[data-drawer-close]', drawer)?.focus();
  };
  const closeDrawer = () => {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open'); document.body.classList.remove('no-scroll'); setInert(false);
    if (drawerReturn && drawerReturn.isConnected && drawerReturn !== document.body) drawerReturn.focus();
    drawerReturn = null;
  };
  const refreshDrawer = async () => {
    const res = await fetch(`${A.routes.root}?section_id=cart-drawer`);
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('#cart-drawer');
    if (fresh && drawer) {
      $('.drawer__panel', drawer).innerHTML = $('.drawer__panel', fresh).innerHTML;
    }
    const cart = await (await fetch(`${A.routes.cart}.js`)).json();
    setCount(cart.item_count);
    return cart;
  };
  const bundleMsg = (count) => {
    if (count >= 3) return `Adăugat. Ai ${A.bundleThree}% reducere în coș`;
    if (count === 2) return `Adăugat. Ai ${A.bundleTwo}% reducere în coș`;
    return 'Adăugat în coș';
  };

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-add-to-cart]');
    if (!form) return;
    e.preventDefault();
    const btn = $('[type="submit"]', form);
    if (form.dataset.busy === 'true' || btn?.disabled || btn?.getAttribute('aria-disabled') === 'true') return;
    form.dataset.busy = 'true';
    const label = btn ? btn.innerHTML : '';
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.textContent = 'Se adaugă…'; }
    try {
      const res = await fetch(`${A.routes.cartAdd}.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Nu am putut adăuga produsul.');
      const cart = await refreshDrawer();
      if (btn) { btn.classList.add('is-done'); btn.textContent = 'Adăugat'; }
      if (A.cartType === 'page') { toast(bundleMsg(cart.item_count)); }
      else { openDrawer(); }
    } catch (err) {
      toast(err.message);
    } finally {
      form.dataset.busy = 'false';
      if (btn) setTimeout(() => { btn.removeAttribute('aria-disabled'); btn.classList.remove('is-done'); btn.innerHTML = label; }, 1400);
    }
  });

  if (drawer) {
    drawer.addEventListener('click', async (e) => {
      if (e.target.closest('[data-drawer-close]')) { closeDrawer(); return; }
      const q = e.target.closest('[data-line]');
      if (!q) return;
      e.preventDefault();
      if (drawer.dataset.busy === 'true') return;
      drawer.dataset.busy = 'true';
      q.setAttribute('aria-disabled', 'true');
      try {
      const response = await fetch(`${A.routes.cartChange}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: +q.dataset.line, quantity: +q.dataset.qty })
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'Cantitatea nu poate fi actualizată.');
      await refreshDrawer();
      } catch (error) { toast(error.message); }
      finally { delete drawer.dataset.busy; q.removeAttribute('aria-disabled'); }
    });
  }
  $$('[data-cart-open]').forEach((b) => b.addEventListener('click', (e) => {
    if (A.cartType === 'page' || !drawer) return;
    e.preventDefault(); openDrawer();
  }));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { closeDrawer(); closeMenu(); } });

  /* ---------- product page ---------- */
  $$('[data-product]').forEach((root) => {
    const json = $('script[type="application/json"][data-product-json]', root);
    if (!json) return;
    const product = JSON.parse(json.textContent);
    const form = $('form[data-add-to-cart]', root);
    const idInput = form && $('input[name="id"]', form);
    const priceEl = $('[data-price]', root);
    const btn = form && $('[type="submit"]', form);
    const sticky = $('.sticky-atc');
    const stickyPrice = sticky && $('[data-sticky-price]', sticky);

    const current = () => $$('.opt', root).map((fs) => { const c = $('input:checked', fs); return c ? c.value : null; });
    const update = () => {
      const sel = current();
      const v = product.variants.find((x) => x.options.every((o, i) => o === sel[i]));
      $$('.opt', root).forEach((fs, i) => {
        const l = $('legend span', fs); if (l) l.textContent = sel[i] || '';
        $$('input', fs).forEach((inp) => {
          const test = sel.slice(); test[i] = inp.value;
          const ok = product.variants.some((x) => x.available && x.options.every((o, j) => o === test[j]));
          inp.classList.toggle('is-unavailable', !ok);
        });
      });
      if (!v) { if (idInput) idInput.value = ''; if (btn) { btn.disabled = true; btn.setAttribute('aria-disabled', 'true'); btn.textContent = 'Indisponibil'; } return; }
      if (idInput) idInput.value = v.id;
      if (priceEl) {
        priceEl.innerHTML = v.compare_at_price > v.price
          ? `${money(v.price)} <s>${money(v.compare_at_price)}</s> <span class="save-pill">−${Math.round(100 - v.price * 100 / v.compare_at_price)}%</span>`
          : money(v.price);
      }
      if (stickyPrice) stickyPrice.textContent = money(v.price);
      if (btn) {
        btn.disabled = !v.available;
        if (v.available) { btn.removeAttribute('aria-disabled'); btn.textContent = 'Adaugă în coș'; }
        else { btn.setAttribute('aria-disabled', 'true'); btn.textContent = 'Stoc epuizat'; }
      }
      if (v.featured_media) {
        const slide = $(`[data-media-id="${v.featured_media.id}"]`, root);
        if (slide) slide.parentElement.scrollTo({ left: slide.offsetLeft - slide.parentElement.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      }
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
    };
    $$('.opt input', root).forEach((i) => i.addEventListener('change', update));

    /* qty */
    const qty = $('.qty input', root);
    $$('.qty button', root).forEach((b) => b.addEventListener('click', () => {
      if (!qty) return; qty.value = Math.max(1, (+qty.value || 1) + (+b.dataset.step)); }));

    /* gallery */
    const main = $('.gallery__main', root);
    const thumbs = $$('.gallery__thumb', root);
    const dots = $$('.gallery__dots span', root);
    thumbs.forEach((t, i) => t.addEventListener('click', () => {
      const s = main.children[i]; main.scrollTo({ left: s.offsetLeft - main.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    }));
    if (main) main.addEventListener('scroll', () => {
      const i = Math.round(main.scrollLeft / main.clientWidth);
      thumbs.forEach((t, j) => t.setAttribute('aria-current', j === i ? 'true' : 'false'));
      dots.forEach((d, j) => d.classList.toggle('is-active', j === i));
    }, { passive: true });

    /* sticky ATC */
    if (sticky && btn && 'IntersectionObserver' in window) {
      const stickyButton = $('button', sticky);
      new IntersectionObserver(([e]) => {
        const visible = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', visible);
        sticky.setAttribute('aria-hidden', String(!visible));
        if (stickyButton) stickyButton.tabIndex = visible ? 0 : -1;
      }).observe(btn);
      stickyButton?.addEventListener('click', () => {
        if (!btn.disabled) form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    }
  });

  /* product recommendations */
  $$('[data-recommendations]').forEach(async (el) => {
    try {
      const res = await fetch(el.dataset.url);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const inner = doc.querySelector('[data-recommendations]');
      if (inner && inner.innerHTML.trim()) { el.innerHTML = inner.innerHTML; $$('.reveal', el).forEach((r) => r.classList.add('is-in')); }
    } catch (_) { /* keep the section empty */ }
  });
})();
